import React, { memo } from "react";
import { useBoard } from "./index.hooks";
import { Box, Grid } from "@mui/material";
import { CountdownDigit, Tile } from "components";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

type BoardProps = {};

export const Board = memo(({}: BoardProps) => {
  const { chosenLevel, countdown, status } = useBoard();

  return (
    <Box
      sx={{
        width: {
          xs: "80%",
          md: "100%",
        },
        maxWidth: 800,
        border: "1px solid #707070",
        position: "relative",
        aspectRatio: "1/1",
        lineHeight: "0!important",
      }}
    >
      {chosenLevel && (
        <>
          {status === GameStatus.COUNTDOWN && countdown > 0 && (
            <CountdownDigit digit={countdown} />
          )}
          {status === GameStatus.COUNTDOWN || status === GameStatus.SUCCESS ? (
            <Box
              component="img"
              src={chosenLevel.fullImage}
              sx={{
                width: "100%",
              }}
            />
          ) : (
            <Grid container direction="column" spacing={0}>
              {new Array(chosenLevel.size).fill(0).map((_, rowIndex) => (
                <Grid container item key={rowIndex} direction="row" spacing={0}>
                  {new Array(chosenLevel.size).fill(0).map((_, columnIndex) => {
                    // This formula lets us pass from a 2D structure to a 1D array
                    const tileIndex = columnIndex + rowIndex * chosenLevel.size;

                    return (
                      <Grid key={columnIndex} item xs>
                        <Tile index={tileIndex} />
                      </Grid>
                    );
                  })}
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}
    </Box>
  );
});
